export interface IUser {
    id: string;
    createdAt: string;
    updated_date: string;
    phone: string;
    first_name: string;
    last_name: string;
    role_id: number;
    status_id: number;
    company_id: string;
    /** Имя файла аватара (`/api/file/static/<имя>`); null — без фото. */
    avatar_path: string | null;
    is_admin: boolean;
}

export interface IUserWithPassport extends IUser {
}

export const defaultUser: IUserWithPassport = {
    id: "",
    createdAt: "",
    updated_date: "",
    phone: "",
    first_name: "",
    last_name: "",
    role_id: -1,
    status_id: 1,
    company_id: "",
    avatar_path: "",
    is_admin: false,
};

export const userRoles = [
    {id: 1, title: "Сотрудник"},
    {id: 2, title: "Сергей"},
    {id: 3, title: "Качество"},
];

export const userStatus = [
    {id: 1, title: "Работает"},
    {id: 2, title: "В отпуске"},
    {id: 3, title: "На больничном"},
    {id: 4, title: "Уволился"},
];

/** Сотрудник — рабочая роль (зеркало MEMBER_ROLE_ID бэкенда). */
export const MEMBER_ROLE_ID = 1;

/**
 * «Только доска» (S6, зеркало BOARD_ROLE_ID бэкенда). Назначается только миграцией.
 * Что ей можно — models/permissions.ts (ROLES.md).
 */
export const BOARD_ROLE_ID = 2;

/** «Качество» (зеркало QUALITY_ROLE_ID бэкенда, S20.2). Права — models/permissions.ts. */
export const QUALITY_ROLE_ID = 3;

/**
 * Роль «Гостевой доступ» — read-only пользователь.
 * Бэкенд режет любые мутации для этой роли guard'ом; на фронте по ней
 * включается read-only UX (см. useIsReadOnly). Один механизм и для
 * демо-режима, и для реальных компаний-наблюдателей.
 */
export const GUEST_ROLE_ID = 1000;
